module.exports = __webpack_public_path__ + "static/img/6.ab15ce3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/6.png
// module id = Crf5
// module chunks = 0